import { getName } from "../../redux/contact/contact.utils";
import { EContractMemberTypes, } from "../../types/contract.types";
import { ERentDepositProvider } from "../../types/rentDeposit.types";
import { formatDate } from "../../utils/date.utils";
import { getLocalizedText } from "../../utils/i18n/i18n.utils";
import { getStore } from "../../utils/redux/redux.utils";
import { EField } from "./schema.releaseRentDeposit.types";
import { customGetForeignerContactsForAccountIds } from "./schema.releaseRentDeposit.utils.fetchContracts";
export var getNavigationTitle = function (_) {
    return getLocalizedText("new.rent_deposit_release.contract");
};
var getDefaultSigners = function (extraData) {
    var rentDeposit = extraData.rentDeposit, relatedContract = extraData.relatedContract;
    var providerIsBanqup = (rentDeposit === null || rentDeposit === void 0 ? void 0 : rentDeposit.provider) &&
        [ERentDepositProvider.Banqup, ERentDepositProvider.Migrated].includes(rentDeposit === null || rentDeposit === void 0 ? void 0 : rentDeposit.provider);
    if (providerIsBanqup) {
        return relatedContract.members
            .filter(function (member) {
            return !member.roles.includes(EContractMemberTypes.Broker) &&
                (member.roles.includes(EContractMemberTypes.Signer) ||
                    member.roles.includes(EContractMemberTypes.Owner));
        })
            .map(function (member) { return member.account.id; });
    }
    return relatedContract.members
        .filter(function (member) {
        return !member.roles.includes(EContractMemberTypes.Broker) &&
            member.roles.includes(EContractMemberTypes.Signer);
    })
        .map(function (member) { return member.account.id; });
};
export var getInitialValues = function (extraData) {
    var _a;
    var relatedContract = extraData.relatedContract, leaseContractDocument = extraData.leaseContractDocument;
    return _a = {},
        _a[EField.TenantAmount] = relatedContract.amount,
        _a[EField.OwnerAmount] = 0,
        _a[EField.BrokerAmount] = 0,
        _a[EField.JudicialRelease] = false,
        _a[EField.LeaseContractDocument] = leaseContractDocument
            ? [leaseContractDocument]
            : undefined,
        _a[EField.Signers] = getDefaultSigners(extraData),
        _a;
};
export var getTenants = function (relatedContract) {
    return relatedContract.members
        .filter(function (member) {
        return member.roles.includes(EContractMemberTypes.Tenant) ||
            member.roles.includes(EContractMemberTypes.Parent);
    })
        .map(function (member) { return member.account; });
};
export var getPayer = function (relatedContract) {
    return relatedContract.members.find(function (member) {
        return member.roles.includes(EContractMemberTypes.Payer);
    });
};
export var getSelectedTenants = function (relatedContract, formData) {
    var tenants = getTenants(relatedContract);
    return tenants.filter(function (member) { return formData[EField.Signers].includes(member.id); });
};
export var getOwners = function (relatedContract) {
    return relatedContract.members
        .filter(function (member) { return member.roles.includes(EContractMemberTypes.Owner); })
        .map(function (member) { return member.account; });
};
export var getIdDocumentsSummary = function (docs) {
    if (docs === void 0) { docs = []; }
    if (!Array.isArray(docs) || docs.length === 0)
        return "";
    var docTypeLabel = getLocalizedText("rent_deposit.documentType.label");
    var dateOfExpiryLabel = getLocalizedText("rent_deposit.id_expiry_date.label");
    var dateOfIssuanceLabel = getLocalizedText("rent_deposit.date_of_issuance.label");
    var countryOfIssuanceLabel = getLocalizedText("rent_deposit.country_of_issuance.label");
    var documentNumberLabel = getLocalizedText("rent_deposit.document_number.label");
    return docs
        .map(function (doc) {
        if (!doc)
            return null;
        var contactName = doc.contact
            ? getName(doc.contact)
            : getLocalizedText("rent_deposit.no_contact");
        if (!doc.docType) {
            return contactName;
        }
        var rawDocType = (doc.documentType || "").toString().trim();
        var docType = rawDocType
            ? getLocalizedText("rent_deposit.documentType.".concat(rawDocType.toLowerCase()))
            : getLocalizedText("rent_deposit.documentType.unknown");
        var expiry = doc.dateOfExpiry
            ? formatDate(doc.dateOfExpiry)
            : getLocalizedText("rent_deposit.not_provided");
        var issuance = doc.dateOfIssuance
            ? formatDate(doc.dateOfIssuance)
            : getLocalizedText("rent_deposit.not_provided");
        var country = doc.countryOfIssuance || getLocalizedText("rent_deposit.not_provided");
        var number = doc.documentNumber || getLocalizedText("rent_deposit.not_provided");
        return [
            "".concat(contactName),
            "".concat(docTypeLabel, ": ").concat(docType),
            "".concat(dateOfExpiryLabel, ": ").concat(expiry),
            "".concat(dateOfIssuanceLabel, ": ").concat(issuance),
            "".concat(countryOfIssuanceLabel, ": ").concat(country),
            "".concat(documentNumberLabel, ": ").concat(number),
        ].join(" | ");
    })
        .filter(Boolean)
        .join(", ");
};
export var getForeigners = function (accountIds) {
    var _a;
    try {
        if (!accountIds) {
            return;
        }
        var state = (_a = getStore()) === null || _a === void 0 ? void 0 : _a.getState();
        if (!state) {
            return;
        }
        return customGetForeignerContactsForAccountIds(state, accountIds);
    }
    catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
    }
};
export var getForeignersForBanqup = function (extraData, includePayer) {
    var selectedPayer = getPayer(extraData.relatedContract);
    var otherSigners = extraData.relatedContract.members
        .filter(function (member) {
        return member.roles.some(function (role) {
            return [
                EContractMemberTypes.Owner,
                EContractMemberTypes.Tenant,
                EContractMemberTypes.Parent,
            ].includes(role);
        });
    })
        .map(function (member) { return member.account.id; });
    var foreigners = getForeigners(otherSigners) || [];
    if (foreigners.length > 0) {
        return foreigners
            .filter(function (contact) {
            if (includePayer) {
                return true;
            }
            return contact.accountId !== (selectedPayer === null || selectedPayer === void 0 ? void 0 : selectedPayer.account.id);
        })
            .map(function (contact) {
            var _a;
            return (_a = {},
                _a[EField.IdentityDocumentAccountId] = contact.accountId,
                _a.contact = contact.account,
                _a);
        });
    }
    return [];
};
export var getShowIdentificationStep = function (formData, extraData) {
    var rentDeposit = extraData.rentDeposit;
    if (!!formData[EField.JudicialRelease]) {
        return false;
    }
    return (rentDeposit === null || rentDeposit === void 0 ? void 0 : rentDeposit.provider) === ERentDepositProvider.Migrated;
};
export var isFileSizeValid = function (file, maxMB) {
    var maxSizeInBytes = maxMB * 1024 * 1024;
    return file.size <= maxSizeInBytes;
};
